//adds common methods and propreties to a given PIXI object
function addCommonProps(obj) {

    //sets transform of an object 
    //optional x, y, scaleX, scaleY, rotation, anchorX, anchorY
    obj.setTransform = function (x, y, scaleX, scaleY, rotation, anchorX, anchorY) {
        if (x != undefined) {
            obj.x = x;
        }
        if (y != undefined) {
            obj.y = y;
        }
        if ((scaleX != undefined) && (scaleY == undefined)) {
            scaleX *= obj.defaultScaleX || 1;
            obj.scale.set(scaleX);
        } else if ((scaleX != undefined) && (scaleY != undefined)) {
            scaleX *= obj.defaultScaleX || 1;
            scaleY *= obj.defaultScaleY || 1;
            obj.scale.set(scaleX, scaleY);
        }

        if (rotation != undefined) {
            obj.rotation = rotation;
        }

        try {
            if ((anchorX != undefined) && (anchorY == undefined)) {
                obj.anchor.set(anchorX);
            } else if ((anchorX != undefined) && (anchorY != undefined)) {
                obj.anchor.set(anchorX, anchorY);
            }
        } catch (e) {}
    }

    //calculates global transform of an object (position, scale, rotation)
    obj.getGlobalTransform = function () {
        var transform = {};
        var parent = obj.parent;
        transform.position = parent.toGlobal(obj.position);
        transform.scale = {
            x: obj.scale.x / (obj.defaultScaleX || 1),
            y: obj.scale.y / (obj.defaultScaleY || 1)
        };
        transform.rotation = obj.rotation;
        while (parent != null) {
            transform.scale.x *= parent.scale.x;
            transform.scale.y *= parent.scale.y;
            transform.rotation += parent.rotation;
            parent = parent.parent;
        }
        return transform;
    }

}

// Container class - based on PIXI.Container
//required: parent
function Container(parent) {
    var t = new PIXI.Container();
    addCommonProps(t);
    t.type = "Container";
    parent.addChild(t);

    //methods
    t.delete = function (deleteChildren) {
        if (deleteChildren == undefined)
            deleteChildren = true;

        if (deleteChildren) {
            var elLength = t.children.length;
            for (var i = elLength - 1; i >= 0; i--) {
                t.children[i].delete();
            }
        }
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy();
        t = null;
    }

    t.toFront = function (child) {
        t.setChildIndex(child, t.children.length - 1);
    }

    t.toBack = function (child) {
        t.setChildIndex(child, 0);
    }

    t.getName = function () {
        return t.type;
    }
    return t;
}

// Sprite class - based on PIXI.Sprite
//required: parent, img;
function Sprite(parent, img) {
    var t;
    if (PIXI.utils.TextureCache[img] != undefined) {
        t = new PIXI.Sprite(PIXI.utils.TextureCache[img]);
    } else {
        t = new PIXI.Sprite(PIXI.Texture.fromImage(img));
    }
    addCommonProps(t);
    t.type = "Sprite";
    t.anchor.set(0.5);
    parent.addChild(t);

    //methods
    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy();
        t = null;
    }

    t.getName = function () {
        return t.type + " - " + t.texture.textureCacheIds[0];
    }

    return t;
}

function TilingSprite(parent, img, size) {
    var t;
    var texture;
    if (PIXI.utils.TextureCache[img] != undefined) {
        texture = (PIXI.utils.TextureCache[img]);
    } else {
        texture = (PIXI.Texture.fromImage(img));
    }
    t = new PIXI.extras.TilingSprite(texture, size[0], size[1]);

    addCommonProps(t);
    t.type = "TilingSprite";
    t.anchor.set(0.5);
    parent.addChild(t);

    //methods
    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy();
        t = null;
    }

    t.getName = function () {
        return t.type + " - " + t.texture.textureCacheIds[0];
    }

    return t;
}

// Animation class - based on PIXI.extras.AnimatedSprite
//required: parent, imgPref
//optional: imgSuf (def: ""), loop (def: false), speed (def: 1);
function Animation(parent, imgPref, imgSuf, loop, speed) {
    var sprite_frames = [];
    imgSuf = imgSuf || "";
    loop = loop || false;
    speed = speed || 1;
    var i = 0;
    while (true) {
        i++;
        var val = i < 10 ? '0' + i : i;
        try {
            sprite_frames.push(PIXI.Texture.fromFrame(imgPref + val + imgSuf + '.png'));
        } catch (error) {
            break;
        }
    }
    var t = new PIXI.extras.AnimatedSprite(sprite_frames);
    addCommonProps(t);
    t.type = "Animation";
    t.reversed = false;
    t.loop = loop;
    t.animationSpeed = speed;
    t.anchor.set(0.5);
    parent.addChild(t);

    //methods
    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy();
        t = null;
    }

    t.revereAnimation = function () {
        t.reverse_prop = !t.reverse_prop;
        t.textures.reverse();
    }

    t.getName = function () {
        return t.type + " - " + t.textures[0].textureCacheIds[0];
    }

    return t;
}

//Spine Animation class - based on PIXI.spine.Spine
//required: parent, spineData
//optional: startAnimation, loop (def: false)
function SpineAnimation(parent, spineData, startAnimation, loop) {
    loop = loop || false;
    var t = new PIXI.spine.Spine(spineData);
    t.skeleton.setToSetupPose();
    t.update(0);
    if (startAnimation != undefined) {
        t.state.setAnimation(0, startAnimation, loop);
    }
    t.type = "Spine Animation"
    addCommonProps(t);
    parent.addChild(t);

    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy();
        t = null;
    }

    t.getName = function () {
        return t.type;
    }



    return t;
}

//Threes sprite class
//required: parent, renderer
function ThreesSprite(parent, renderer) {
    var texture = PIXI.BaseTexture.fromCanvas(renderer.domElement, PIXI.SCALE_MODES.LINEAR);
    var t = new PIXI.Sprite.from(new PIXI.Texture(texture));
    t.type = "Threes Sprite";
    addCommonProps(t);
    parent.addChild(t);
    t.anchor.set(0.5);
    t.update = function () {
        t.texture.update();
    }

    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy(true);
        t = null;
    }

    t.getName = function () {
        return t.type;
    }

    return t;
}

//Text class - based on PIXI.Text
//required: parrent
//optional: text (def: ""), textStyle
function Text(parent, text, textStyle) {
    text = text || "";
    var t = new PIXI.Text(text, textStyle);
    addCommonProps(t);
    t.type = "Text";
    t.anchor.set(0.5);
    parent.addChild(t);

    //methods
    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy(true);
        t = null;
    }

    t.getName = function () {
        return t.type + " - " + t.text;
    }

    return t;
}

//Circle class - based on PIXI.Graphics
//required: parent, radius
//optional: lineStyle(def: [0,0,0]), fillStyle (def:[0xFFFFFF,1]), convertToSprite (def: true)
function Circle(parent, radius, lineStyle, fillStyle, convertToSprite) {
    if (convertToSprite == undefined)
        convertToSprite = true;
    lineStyle = lineStyle || [0, 0, 0];
    fillStyle = fillStyle || [0xFFFFFF, 1];

    var g = new PIXI.Graphics();
    if (lineStyle.length > 0) {
        g.lineStyle(lineStyle[0], lineStyle[1], lineStyle[2]);
    }
    if (fillStyle.length > 0) {
        g.beginFill(fillStyle[0], fillStyle[1]);
    } else {
        g.beginFill();
    }
    g.drawCircle(0, 0, radius);
    g.endFill();
    if (convertToSprite) {
        var t = new PIXI.Sprite(g.generateCanvasTexture(PIXI.settings.SCALE_MODE, 2));
        t.anchor.set(0.5);
        t.type = "Circle Sprite";
    } else {
        var t = g;
        t.type = "Circle Graphics";
    }

    addCommonProps(t);
    t.convertedToSprite = convertToSprite;

    parent.addChild(t);

    //methods
    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy(t.convertedToSprite);
        t = null;
    }

    t.getName = function () {
        return t.type;
    }

    return t;
}

//CircularSector class - based on PIXI.Graphics
//required: parent, radius, startAngle, endAngle
//optional: lineStyle(def: [0,0,0]), fillStyle (def:[0xFFFFFF,1]), convertToSprite (def: true)
function CircularSector(parent, radius, startAngle, endAngle, lineStyle, fillStyle, convertToSprite) {
    if (convertToSprite == undefined)
        convertToSprite = true;
    lineStyle = lineStyle || [0, 0, 0];
    fillStyle = fillStyle || [0xFFFFFF, 1];

    var g = new PIXI.Graphics();
    if (convertToSprite) {
        g.lineStyle(lineStyle[0], 0, 0);
        g.beginFill(0xFFFFFF, 0);
        g.drawCircle(0, 0, radius);
        g.endFill();
    }
    if (lineStyle.length > 0) {
        g.lineStyle(lineStyle[0], lineStyle[1], lineStyle[2]);
    }
    g.beginFill(fillStyle[0], fillStyle[1]);
    g.moveTo(0, 0);

    g.arc(0, 0, radius, degToRad(startAngle), degToRad(endAngle));
    g.lineTo(0, 0);
    g.endFill();
    if (convertToSprite) {
        var t = new PIXI.Sprite(g.generateCanvasTexture(PIXI.settings.SCALE_MODE, 2));
        t.anchor.set(0.5);
        t.type = "Circular Sector Sprite";
    } else {
        var t = g;
        t.type = "Circular Sector Graphics";
    }

    addCommonProps(t);
    t.convertedToSprite = convertToSprite;

    parent.addChild(t);

    //methods
    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy(t.convertedToSprite);
        t = null;
    }

    t.getName = function () {
        return t.type;
    }

    return t;
}
//Pie class - based on PIXI.Graphics
//required: parent, radius, angles(ex: [0,30,90,180,300,360])
//optional: lineStyle(def: [0,0,0]), colors (def:random color), convertToSprite (def: true)
function Pie(parent, radius, angles, lineStyle, colors, convertToSprite) {
    if (convertToSprite == undefined)
        convertToSprite = true;
    lineStyle = lineStyle || [0, 0, 0];
    colors = colors || [];
    var t = new Container(parent);

    t.sectors = [];
    for (var i = 0; i < angles.length - 1; i++) {
        t.sectors[i] = new CircularSector(t, radius, angles[i], angles[i + 1], lineStyle, [(colors[i] || randomColor()), 1], convertToSprite);
    }

    t.convertedToSprite = convertToSprite;
    if (convertToSprite) {
        t.type = "Pie Sprite";
    } else {
        var t = g;
        t.type = "Pie Graphics";
    }

    t.getName = function () {
        return t.type;
    }

    return t;
}
//RadarChart class - based on PIXI.Graphics
//required: parent, radius, numOfParams
//optional: numOfSegments (def:2), convertToSprite (def: true)
function RadarChart(parent, radius, numOfParams, numOfSegments, convertToSprite) {
    if (convertToSprite == undefined)
        convertToSprite = true;


    var t = new Container(parent);
    t.convertedToSprite = convertToSprite;
    if (convertToSprite) {
        t.type = "Radar Chart Sprite";
    } else {
        t.type = "Radar Chart Graphics";
    }


    t.numOfParams = numOfParams;
    t.numOfLines = 0;
    t.numOfSegments = numOfSegments || 2;
    t.lines = [];
    t.values = [];
    t.points = [];
    //circles

    t.circles = [];
    t.circleRadiuses = [];
    t.circleLineStyles = [[5, 0x000000, 1], [2, 0x000000, 0.1]];
    for (var i = 0; i <= t.numOfSegments; i++) {
        t.circleRadiuses[i] = radius * 0 + (t.numOfSegments - i) * radius * 1 / t.numOfSegments;
        if (i == 0) {
            t.circles[i] = new Circle(t, t.circleRadiuses[i], t.circleLineStyles[0], [0xffffff, 1], convertToSprite);
        } else if (i == t.numOfSegments) {
            t.circles[i] = new Circle(t, t.circleRadiuses[i], t.circleLineStyles[0], [0x000000, 1], convertToSprite);
        } else {
            t.circles[i] = new Circle(t, t.circleRadiuses[i], t.circleLineStyles[1], [0xffffff, 1], convertToSprite);
        }
    }


    //param lines and names
    t.paramLines = new PIXI.Graphics();
    t.paramNames = [];
    if (t.convertedToSprite) {
        t.paramLines.lineStyle(0, 0, 0);
        t.paramLines.beginFill(0xFFFF00, 0);
        t.paramLines.drawCircle(0, 0, t.circleRadiuses[0]);
        t.paramLines.endFill();
    }
    t.paramLines.lineStyle(t.circleLineStyles[1][0], t.circleLineStyles[1][1], t.circleLineStyles[1][2]);
    for (var i = 0; i < t.numOfParams; i++) {
        var angle = Math.PI + Math.PI * 2 * i / t.numOfParams;
        var x = Math.sin(angle) * radius;
        var y = Math.cos(angle) * radius;
        t.paramLines.moveTo(0, 0);
        t.paramLines.lineTo(x, y);

        t.paramNames[i] = new Text(t);
        x = Math.sin(angle) * (radius + 20);
        y = Math.cos(angle) * (radius + 20);
        t.paramNames[i].position.set(x, y);
        t.paramNames[i].anchor.set(1 - (Math.sin(angle) / 2 + 0.5), 1 - (Math.cos(angle) / 2 + 0.5));
    }
    if (t.convertedToSprite) {
        t.paramLines = (new PIXI.Sprite(t.paramLines.generateTexture()));
        t.paramLines.anchor.set(0.5);
    }
    t.addChild(t.paramLines);
    t.paramLines.delete = function () {
        this.destroy(this.parent.convertedToSprite);
    }
    t.toFront(t.circles[t.numOfSegments]);




    //methods
    t.drawLine = function (val, style, lineIndex) {
        var style = style || [5, 0x000000, 1];
        if (lineIndex == undefined)
            lineIndex = t.lines.length;

        var g = new PIXI.Graphics();
        var line = {};

        if (t.convertedToSprite) {
            g.lineStyle(0, 0, 0);
            g.beginFill(0xFFFF00, 0);
            g.drawCircle(0, 0, t.circleRadiuses[0]);
            g.endFill();
        }
        g.lineStyle(style[0], style[1], style[2]);
        var pointsContainer = new Container(t);
        var points = [];
        var path = [];
        for (var i = 0; i < t.numOfParams; i++) {
            var angle = Math.PI + Math.PI * 2 * i / t.numOfParams;
            var r = t.circleRadiuses[t.numOfSegments] + (t.circleRadiuses[0] - t.circleRadiuses[t.numOfSegments]) * val[i];
            var x = Math.sin(angle) * r;
            var y = Math.cos(angle) * r;
            path.push(new PIXI.Point(x, y));
            points[i] = new Circle(pointsContainer, style[0], [0, 0, 0], [style[1], style[2]]);
            points[i].position.set(x, y);
        }

        g.drawPolygon(path);

        if (t.convertedToSprite) {
            line = (new PIXI.Sprite(g.generateCanvasTexture(PIXI.settings.SCALE_MODE, 2)));
            line.anchor.set(0.5);

        } else {
            line = g;
        }
        t.addChild(line);
        line.delete = function () {
            line.destroy(line.parent.convertedToSprite);
        }
        line.style = style;
        t.lines[lineIndex] = line;
        t.points[lineIndex] = pointsContainer;
        t.values[lineIndex] = val;
    }


    t.updateLine = function (val, lineIndex) {
        lineIndex = lineIndex || 0;
        var lineStyle = [5, 0x000000, 1];
        if (t.lines[lineIndex]) {
            lineStyle = t.lines[lineIndex].style;
            t.lines[lineIndex].delete();
            t.points[lineIndex].delete();
        }

        t.drawLine(val, lineStyle, lineIndex);
    }

    //dodati ease
    //dodati ease
    //dodati ease
    t.animateLine = function (val, duration, lineIndex) {
        lineIndex = lineIndex || 0;
        if (duration == undefined)
            duration = 200;


        for (var i = 0; i < duration; i += 20) {
            var currentVal = [];
            for (var j = 0; j < val.length; j++) {
                currentVal[j] = t.values[lineIndex][j] + (val[j] - t.values[lineIndex][j]) * i / duration;
            }
            setTimeout(function (v, ind) {
                t.updateLine(v, ind);
            }, i, currentVal, lineIndex);
        }

        setTimeout(function (v, ind) {
            t.updateLine(v, ind);
        }, duration, val, lineIndex);
    }

    t.getName = function () {
        return t.type;
    }

    t.setParamNames = function (paramNames, textStyle) {
        for (var i = 0; i < t.numOfParams; i++) {
            t.paramNames[i].text = paramNames[i];
            if (textStyle)
                t.paramNames[i].style = textStyle;
        }
    }



    return t;
}


//Rectangle class - based on PIXI.Graphics
//required: parent, size[width, height];
//optional: size[,,borderRadius], lineStyle[tickness, color, alpha], fillStyle[color,alpha], convertToSprite(def: true), 
function Rectangle(parent, size, lineStyle, fillStyle, convertToSprite) {
    if (convertToSprite == undefined)
        convertToSprite = true;
    size[2] = size[2] || 0;
    lineStyle = lineStyle || [0, 0, 0];
    fillStyle = fillStyle || [0xFFFFFF, 1];

    var g = new PIXI.Graphics();
    if (lineStyle.length > 0) {
        g.lineStyle(lineStyle[0], lineStyle[1], lineStyle[2]);
    }
    if (fillStyle.length > 0) {
        g.beginFill(fillStyle[0], fillStyle[1]);
    } else {
        g.beginFill();
    }


    if (convertToSprite) {
        g.drawRoundedRect(0, 0, size[0], size[1], size[2]);
        g.endFill();
        var t = new PIXI.Sprite(g.generateCanvasTexture(PIXI.settings.SCALE_MODE, 2));
        t.anchor.set(0.5);
        t.type = "Rectangle Sprite";
    } else {
        g.drawRoundedRect(-size[0] * 0.5, -size[1] * 0.5, size[0], size[1], size[2]);
        g.endFill();
        var t = g;
        t.type = "Rectangle Graphics";
    }
    addCommonProps(t);
    t.convertedToSprite = convertToSprite;
    parent.addChild(t);

    //methods
    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy(t.convertedToSprite);
        t = null;
    }

    t.getName = function () {
        return t.type;
    }


    return t;

}

//Polygon class - based on PIXI.Graphics
//required: parent, radius, sides; 
//optional: lineStyle[tickness, color, alpha], fillStyle[color,alpha], convertToSprite(def: true)
function Polygon(parent, radius, sides, lineStyle, fillStyle, convertToSprite) {
    if (convertToSprite == undefined)
        convertToSprite = true;
    lineStyle = lineStyle || [0, 0, 0];
    fillStyle = fillStyle || [0xFFFFFF, 1];

    var g = new PIXI.Graphics();
    if (lineStyle.length > 0) {
        g.lineStyle(lineStyle[0], lineStyle[1], lineStyle[2]);
    }
    if (fillStyle.length > 0) {
        g.beginFill(fillStyle[0], fillStyle[1]);
    } else {
        g.beginFill();
    }
    var path = [];
    for (var i = 0; i < sides; i++) {
        var angle = 2 * Math.PI * (i + 0.5) / sides;
        var x = Math.sin(angle) * radius;
        var y = Math.cos(angle) * radius;
        path.push(new PIXI.Point(x, y));
    }

    g.drawPolygon(path);
    g.endFill();

    if (convertToSprite) {
        var t = new PIXI.Sprite(g.generateCanvasTexture(PIXI.settings.SCALE_MODE, 2));
        t.anchor.set(0.5);
        t.type = "Polygon Sprite";
    } else {
        var t = g;
        t.type = "Polygon Graphics";
    }
    addCommonProps(t);
    t.convertedToSprite = convertToSprite;
    parent.addChild(t);

    //methods
    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy(t.convertedToSprite);
        t = null;
    }

    t.getName = function () {
        return t.type;
    }

    return t;

}

//Star class - based on PIXI.Graphics
//required: parent, radiuses[r1,r2]; 
//optional: lineStyle[tickness, color, alpha], fillStyle[color,alpha], convertToSprite(def: true)
function Star(parent, radiuses, sides, lineStyle, fillStyle, convertToSprite) {
    if (convertToSprite == undefined)
        convertToSprite = true;
    lineStyle = lineStyle || [0, 0, 0];
    fillStyle = fillStyle || [0xFFFFFF, 1];
    radiuses.sort(function (a, b) {
        return a - b;
    });

    var g = new PIXI.Graphics();
    if (lineStyle.length > 0) {
        g.lineStyle(lineStyle[0], lineStyle[1], lineStyle[2]);
    }
    if (fillStyle.length > 0) {
        g.beginFill(fillStyle[0], fillStyle[1]);
    } else {
        g.beginFill();
    }
    var path = [];
    for (var i = 0; i < sides * 2; i++) {
        var angle = Math.PI * i / sides;
        var x = Math.sin(angle) * radiuses[i % 2];
        var y = Math.cos(angle) * radiuses[i % 2];
        path.push(new PIXI.Point(x, y));
    }

    g.drawPolygon(path);
    g.endFill();

    if (convertToSprite) {
        var t = new PIXI.Sprite(g.generateCanvasTexture(PIXI.settings.SCALE_MODE, 2));
        t.anchor.set(0.5);
        t.type = "Star Sprite";
    } else {
        var t = g;
        t.type = "Star Graphics";
    }
    addCommonProps(t);
    t.convertedToSprite = convertToSprite;
    parent.addChild(t);

    //methods
    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy(t.convertedToSprite);
        t = null;
    }

    t.getName = function () {
        return t.type;
    }

    return t;

}

//Dust class
//required: parent, numOfParticles, radius
//optional: colors(def: [0xFFFFFF]); scaleDeviation(def: 0)
function Dust(parent, radius, numOfParticles, colors, scaleDeviation) {
    if (colors == undefined)
        colors = [0xFFFFFF];
    scaleDeviation = scaleDeviation || 0;

    var t = new Container(parent);
    t.type = "Dust";
    t.numOfParticles = numOfParticles;
    t.colors = colors;
    t.particles = [];
    for (var i = 0; i < t.numOfParticles; i++) {

        t.particles[i] = new Circle(t, radius * (1 + scaleDeviation));
        t.particles[i].reset = function () {
            this.x = random(APP.screen.width);
            this.y = random(APP.screen.height);
            this.xSpeed = Math.random() * 1 - 0.5;
            this.ySpeed = Math.random() * 1 - 0.5;
            this.currentFrame = 0;
            this.duration = random(100, 200);
            this.tint = randomElement(t.colors);
            this.scale.set((ratio_scale / (1 + scaleDeviation)) * (1 + random(-scaleDeviation * 100, scaleDeviation * 100) * 0.01));
        }

        t.particles[i].reset();
    }

    //methods
    t.reset = function () {
        for (var i = 0; i < t.numOfParticles; i++) {
            t.particles[i].reset();
        }
    }

    t.update = function (delta) {
        for (var i = 0; i < t.numOfParticles; i++) {
            t.particles[i].currentFrame += delta;
            t.particles[i].x += t.particles[i].xSpeed * delta * ratio_scale;
            t.particles[i].y += t.particles[i].ySpeed * delta * ratio_scale;
            if (t.particles[i].currentFrame <= 20) {
                t.particles[i].alpha = t.particles[i].currentFrame / 20;
            }
            if (t.particles[i].currentFrame >= t.particles[i].duration - 20) {
                t.particles[i].alpha = (t.particles[i].duration - t.particles[i].currentFrame) / 20;
            }

            if (t.particles[i].currentFrame >= t.particles[i].duration) {
                t.particles[i].reset();
            }
        }
    }

    t.delete = function () {
        for (var i = t.numOfParticles - 1; i >= 0; i--) {
            t.particles[i].delete();
        }
        TweenMax.killTweensOf(t);
        APP.ticker.remove(t.update);
        resize_methods.splice(resize_methods.indexOf(t.reset), 1);
        parent.removeChild(t);
        t.destroy();
        t = null;
    }

    t.getName = function () {
        return t.type;
    }

    APP.ticker.add(t.update);
    resize_methods.push(t.reset);

    return t;

}

function Explosion(parent, radius, texture, numOfParticles, duration, colors) {
    if (colors == undefined)
        colors = [0xFFFFFF];

    duration = duration || 0.25;

    if (typeof texture == "string") {
        if (PIXI.utils.TextureCache[texture] != undefined) {
            texture = PIXI.utils.TextureCache[texture];
        } else {
            texture = PIXI.Texture.fromImage(texture);
        }
    }
    var t = new Container(parent);
    t.type = "Particles";
    t.numOfParticles = numOfParticles;
    t.colors = colors;
    t.particles = [];
    for (var i = 0; i < t.numOfParticles; i++) {

        t.particles[i] = new PIXI.Sprite(texture);
        t.addChild(t.particles[i]);
        t.particles[i].tint = colors[i%colors.length];
        if (t.numOfParticles%2==0)
            var angle = degToRad(180/t.numOfParticles+360*i/t.numOfParticles);
        else
            var angle = degToRad(-90/t.numOfParticles+360*i/t.numOfParticles);
        
        t.particles[i].rotation=angle;
        t.particles[i].endX = Math.cos(angle) * radius;
        t.particles[i].endY = Math.sin(angle) * radius;
        t.particles[i].posTween=TweenMax.to(t.particles[i], duration, {
            pixi: {
                x: t.particles[i].endX,
                y: t.particles[i].endY,
                //alpha: 0,
            },
            ease: Power2.easeOut,
            delay: 0,
            onComplete: function (i) {
                if (i==t.numOfParticles-1)
                {
                    t.delete();
                }
            },
            onCompleteParams: [i]

        });
        t.particles[i].scaleTween=TweenMax.to(t.particles[i], duration*0.33, {
            pixi: {
                scale: 0,
            },
            ease: Power2.easeOut,
            delay: duration*0.66,

        });
        t.particles[i].delete = function () {
            TweenMax.killTweensOf(this);
            this.parent.removeChild(this);
            this.destroy();
        }

    }
    
    t.delete = function () {
        for (var i = t.numOfParticles - 1; i >= 0; i--) {
            t.particles[i].delete();
        }
        TweenMax.killTweensOf(t);
        t.parent.removeChild(t);
        t.destroy();
        t = null;
    }



    t.getName = function () {
        return t.type;
    }

    return t;

}

function Waves(parent, radius, lineWidth, numOfWaves, duration, colors)
{
     if (colors == undefined)
        colors = [0xFFFFFF];

    duration = duration || 0.25;
    
    var t = new Container(parent);
    t.type = "Waves";
    t.numOfWaves = numOfWaves;
    t.colors = colors;
    t.waves = [];
    for (var i = 0; i < t.numOfWaves; i++) {

        t.waves[i] = new Circle(t,radius,[lineWidth,0xFFFFFF,1],[0,0]);
        t.waves[i].tint = colors[i%colors.length];
        t.waves[i].scale.set(0);
        
        t.waves[i].scaleTween=TweenMax.to(t.waves[i], duration, {
            pixi: {
                scale: 1,
            },
            ease: Power2.easeOut,
            delay: i*0.2,
            onComplete: function (i) {
                if (i==t.numOfWaves-1)
                {
                    t.delete();
                }
            },
            onCompleteParams: [i]

        });
        
        t.waves[i].alphaTween=TweenMax.to(t.waves[i], duration*0.2, {
            pixi: {
                alpha: 0,
            },
            ease: Power2.easeOut,
            delay: i*0.2+duration*0.8,

        });

    }



    t.getName = function () {
        return t.type;
    }

    return t;
}

//White Rectangle class - based on PIXI.Texture.WHITE
//required: parent, size[width, height]; 
//optional: color (def: 0xFFFFFF)
function WhiteRectangle(parent, size, color) {
    if (color == undefined)
        color = 0xFFFFFF;
    var t = new PIXI.Sprite(PIXI.Texture.WHITE);
    t.width = size[0];
    t.height = size[1];
    t.defaultScaleX = t.scale.x;
    t.defaultScaleY = t.scale.y;
    t.tint = color;
    t.type = "White Rectangle Sprite";
    addCommonProps(t);
    t.anchor.set(0.5);
    parent.addChild(t);

    //methods
    t.delete = function () {
        TweenMax.killTweensOf(t);
        parent.removeChild(t);
        t.destroy();
        t = null;
    }

    t.getName = function () {
        return t.type;
    }
    return t;
}
